import {areEqual, fieldValue} from "./NamaCommon";
import {prepareMetadataFieldsParents} from "./Metadata";
import * as FieldType from '../constants/FieldType'

/**
 *
 * @param o1
 * @param o2
 * @param {namaTypes.NaMaMetaData}metadata
 */
export function jsLogsEnabled() {
    return false;
}
export function areTwoObjectsEqual(o1, o2, metadata, ...ignoreFields) {
    prepareMetadataFieldsParents(metadata)
    ignoreFields.sort()
    for (let field of metadata.fieldsMetaData) {
        if (field.detail)
            continue;
        if (field.guiField)
            continue;
        if (ignoreFields.binaryContains(field.fieldId))
            continue;
        if (field.parentDetail)
            continue;
        let o1v = fieldValue(o1, field.fieldId);
        let o2v = fieldValue(o2, field.fieldId);
        if (!checkEqual(o1v, o2v, field)) {
            if (jsLogsEnabled()) {
                console.log("not equal field: ", field.id)
                console.log(o1v)
                console.log(o2v)
            }
            return false;
        }
    }
    /**
     * @type {Map.<String,namaTypes.FieldMetaData>}
     */
    let detailFields = metadata.detailFields;
    for (let [detailId, detailField] of detailFields.entries()) {
        let o1lines = fieldValue(o1, detailField.fieldId)
        let o2lines = fieldValue(o2, detailField.fieldId)
        if (o1lines === o2lines)
            continue;
        if (!o1lines || !o2lines)
            return false;
        if (o1lines.length !== o2lines.length)
            return false;
        /**
         * @type {namaTypes.FieldMetaData[]}
         */
        let subFields = detailField.subFields || [detailField];
        for (let subField of subFields) {
            if (subField.detail)
                continue;
            if (subField.guiField)
                continue;
            if (ignoreFields.binaryContains(subField.fieldId))
                continue;
            let trimmedFieldId = subField.fieldId.substring(detailId.length + 1)
            for (let i = 0; i < o1lines.length; i++) {
                let o1Line = o1lines[i], o2line = o2lines[i];
                let o1v = fieldValue(o1Line, trimmedFieldId);
                let o2v = fieldValue(o2line, trimmedFieldId);
                if (!checkEqual(o1v, o2v, subField))
                    return false;
            }
        }
    }
    return true;
}

/**
 *
 * @param {namaTypes.DTOLargeData} o1
 * @param {namaTypes.DTOLargeData} o2
 * @param {namaTypes.FieldMetaData} fieldMetadata
 */
function checkEqual(o1, o2, fieldMetadata) {
    if (!o1 && !o2)
        return true;
    if (areEqual(o1, o2))
        return true;
    if (fieldMetadata.fieldType === FieldType.Binary) {
        let o1info = o1 ? o1.attachmentInfo : null;
        let o2info = o2 ? o2.attachmentInfo : null;
        o1info = o1info || {};
        o2info = o2info || {};
        return (o1info).fileId === o2info.fileId && o1info.updated === o2info.updated && o1info.removed === o2info.removed;
    }
    return false;
}